import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueOffline from 'vue-offline'
import VueGeolocation from 'vue-browser-geolocation'
import VueSocialSharing from 'vue-social-sharing'
import VueMeta from 'vue-meta'
import VueGtag from 'vue-gtag'

import './assets/css/global.css'

Vue.use(VueMeta)
Vue.use(VueGeolocation)
Vue.use(VueSocialSharing)
Vue.use(VueOffline)
Vue.use(VueGtag, {
  config: { id: 'UA-1650432-8' }
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
